<div class="symbols-title-row">
  <h3 class="mb-0"><b>Impersonate User</b></h3>
  <div *ngIf="canImpersonate" class="company-picker">
    <span class="company-picker-label">Client</span>
    <p-dropdown (onChange)="loadClientsUsers()" [(ngModel)]="selectedClient"
                [filter]="true"
                [options]="listClientsForClientDropDown"
                [showClear]="true"
                placeholder="Choose an account"
                scrollHeight="700px"></p-dropdown>
  </div>
</div>

<div *ngIf="canImpersonateChecked && !canImpersonate" class="alert alert-danger" style="font-size: 13px;">
  <span>You are not allowed to impersonate users. Access requires the appropriate role and an authorized IP address.</span>
</div>

<div *ngIf="canImpersonate && !loading">
  <div *ngIf="!selectedClient" class="impersonate-empty-state">
    <i class="fa fa-user-circle-o"></i>
    <p>Choose a client above to see its users.</p>
  </div>

  <div *ngIf="selectedClient && usersList.length == 0" class="alert alert-warning" style="font-size: 13px;">
    <span> The selected company does not have an active user. </span>
  </div>

  <div class="symbols-market-table" *ngIf="usersList.length > 0">
    <p-table [columns]="usersTableColumns" [tableStyle]="{'table-layout':'auto'}"
             [value]="usersList"
             id="users-list-table">
      <ng-template let-columns pTemplate="header">
        <tr>
          <th *ngFor="let column of usersTableColumns" [className]="column.class"
              [pSortableColumnDisabled]="column.sortDisabled"
              [pSortableColumn]="column.field" class="p-sortable-column ng-star-inserted">
            {{ column.header }}

            <p-sortIcon *ngIf="!column.sortDisabled" [field]="column.field"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template [ngForOf]="usersList" let-user ngFor pTemplate="body">
        <tr>
          <td>
            {{ user.email }}
          </td>
          <td>
            {{ user.name }}
          </td>
          <td>
            {{ parseToStringRoles(user) }}
          </td>
          <td>
            {{ user.lastLogin | date : "MMM d, y H:mm" }}
          </td>
          <td>
            <button *ngIf="!user.mustChangePassword && !user.isNotificationOnly"
                    (click)="impersonateUser(user.email)" class="btn-impersonate"
                    id="add_top_button" type="button">Impersonate
            </button>
            <span *ngIf="user.mustChangePassword" class="impersonate-status-pill pill-danger">Password reset required</span>
            <span *ngIf="user.isNotificationOnly" class="impersonate-status-pill pill-neutral">Distribution list</span>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="summary">
        {{ usersList.length }} results
      </ng-template>
    </p-table>
  </div>
</div>
